import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {NotificationsService} from 'angular2-notifications';

import {GenericModalComponent} from '../../generic-modal/generic-modal.component';
import {LoginService} from '../../services/login.service';
import {ModalService} from '../../services/modalService/modal.service';
import {ApiService} from "../../services/api.service";
import {TranslateService} from '@ngx-translate/core';
export interface Model {
  title: string;
  data: any;
}

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent extends DialogComponent<Model, string> implements OnInit {

  title: string;
  data: any;
  resetid: string;
  action: string;
  resetPwd: FormGroup;
  reset: any = {};
  error: any;

  constructor(dialogService: DialogService,
              private apiService: ApiService,
              private loginService: LoginService,
              private modalService: ModalService,
              private notifications: NotificationsService,
              private fb: FormBuilder,
              private translate: TranslateService) {
    super(dialogService);
  }

  ngOnInit() {
    this.resetid = this.data.resetid;
    this.resetPwd = this.fb.group({
      'newPassword': ['', Validators.compose([Validators.required])],
      'confirmPassword': ['', Validators.compose([Validators.required])]
    }, {validator: this.customValidator});
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }

  customValidator(group: FormGroup) {
    const newPassword = group.controls.newPassword.value;
    const confirmPassword = group.controls.confirmPassword.value;
    return newPassword === confirmPassword ? null : {notEqual: true};
  }

  resetPassword(resetData) {
    resetData.passwordResetId = this.resetid;
    this.loginService.resetPassword(resetData)
      .subscribe((res) => {
    	window.location.href='/#/home';
        this.close();
        this.modalService.open(GenericModalComponent, {
          title: this.translate.instant('common.success'),
          data: {
            order : 0,
        	addFooterBtn : true,
        	isCancel: true,
        	cancelText: this.translate.instant('common.continue'),
            centered: true,
            message: this.translate.instant('account.resetPass.resetSuccess')
          }
        }).subscribe((modal) => {
        });
      }, (error) => {
    	  if(error.status == 0) {
      		window.location.href='/#/error-page';
      		this.close();
        	} else {
        		this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('account.resetPass.resetFail')));
        	}
      });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/account/reset-password/reset-password.component.ts